import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { UPDATE_NAV_ITEM } from 'store/modules/competition-nav/actions';
import { navSelector } from 'store/modules/competition-nav/selectors/nav-selector';
import { Loader } from 'common/react/components/Loader';

import { RoundButton } from './RoundButton';

export const RoundListNavItem = () => {
    const dispatch = useDispatch();
    const nav = useSelector(navSelector);

    const season = useSelector(
        (state) =>
            state.seasons[`competition_${nav.competition.id}`]?.[
                `season_${nav.season.id}`
            ]
    );

    const roundsLoadError = useSelector(
        (state) => state.rounds[`season_${nav.season.id}`]?.error
    );

    const roundsList = useSelector(
        (state) => state.rounds[`season_${nav.season.id}`]?.list
    );

    if (roundsLoadError) {
        return null;
    }

    if (!roundsList) {
        return (
            <ul className="competition-nav__round-list">
                <Loader />
            </ul>
        );
    }

    const onNavItemClick = (event, label, disableRounds) => {
        if (label && disableRounds) {
            const matchToScroll =
                document.querySelector(`[data-round-id='${label.id}']`) || null;

            if (matchToScroll) {
                const navOffset = -140;
                const scrollTo =
                    matchToScroll.getBoundingClientRect().top +
                    window.scrollY +
                    navOffset;

                window.scrollTo({ top: scrollTo, behavior: 'smooth' });
            }
        }

        dispatch(
            UPDATE_NAV_ITEM.request({
                navItem: 'round',
                value: label
            })
        );
    };

    return (
        <ul className="competition-nav__round-list">
            {roundsList.length
                ? roundsList.map((round, index) => (
                      <RoundButton
                          key={index}
                          round={round}
                          currentRoundNumber={season?.currentRoundNumber ?? -1}
                          onClick={onNavItemClick}
                      />
                  ))
                : ''}
        </ul>
    );
};
